const state = () => ({
  allData: [],
  dataDetail: [],
  totalData: 0,
  loading: false,
  errors: [],
  item: null,
  totalPage: 0,
  requestData: null,
  loadingGenerate: false,
  pairKey: null
});

export default state;
